import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BlockType } from '../models';
import { EditorComponent } from '@progress/kendo-angular-editor';

@Component({
  selector: 'app-email-content-editor',
  templateUrl: './email-content-editor.component.html',
  styleUrls: ['./email-content-editor.component.scss'],
  standalone: false
})
export class EmailContentEditorComponent {
  @ViewChild('kendoEditor') kendoEditor!: EditorComponent;
  @ViewChild('editorWrapper') editorWrapper!: ElementRef;

  @Input() sIndex!: number;
  @Input() cIndex!: number;
  @Input() bIndex!: number;
  @Input() bodyType!: BlockType;
  @Input() content: any;
  @Input() isSelected: boolean = false;
  @Input() selectedBlock: any;

  @Output() contentChange = new EventEmitter<any>();

  blockType = BlockType;
  editorContent: string = '';

  constructor() {}

  ngOnInit() {
    this.editorContent = this.content || '';
  }

  onEditorChange(content: string) {
    this.contentChange.emit({ content });
  }
}
